/* eslint-disable no-restricted-syntax */
import MicroCMSAdapter from "./_MicroCMSAdapter";
import { EXHIBITOR_COMPANY_OVERVIEW_LIST, IS_DEBUG } from "./_constants";


const params = (new URL(document.location.href)).searchParams
const id = params.get("id");

const microCMSAdapter = new MicroCMSAdapter();

const exhibitorElement = document.querySelector<HTMLElement>(
  ".p-single-exhibitors-section-main"
);
if (!exhibitorElement) {
  throw new Error("exhibitorElement is null");
}
function myError(errorString: string) {
  const titleElement = document.querySelector(".p-single-exhibitors-section-main__title");
  if (!titleElement) {
    throw new Error("titleElement is null");
  }
  titleElement.classList.add("p-single-exhibitors-section-main__title--error");
  titleElement.textContent = errorString;

}

if (id) {


  microCMSAdapter.getExhibitorDetailAsync(id).then((exhibitor) => {

    if (exhibitor.theme.length !== 1) {
      throw new Error("exhibitor.theme.length must be 1");
    }
    document.querySelectorAll(".p-single-exhibitors-section-main__theme").forEach((themeElement) => {
      if (themeElement.classList.contains(`p-single-exhibitors-section-main__theme--${exhibitor.theme[0]}`)) {
        themeElement.classList.remove("p-single-exhibitors-section-main__theme--loading");
      } else {
        themeElement.remove();
      }
    })

    const mainImageElement = document.querySelector<HTMLImageElement>(".p-single-exhibitors-section-main__main-image");
    if (!mainImageElement) {
      throw new Error("mainImageElement is null");
    }
    mainImageElement.src = exhibitor.posterMainImage.url

    const profileLogoElement = document.querySelector<HTMLImageElement>(".p-single-exhibitors-section-main__profile-logo");
    if (!profileLogoElement) {
      throw new Error("profileLogoElement is null");
    }
    profileLogoElement.src = exhibitor.companyLogo.url

    const titleElement = document.querySelector(".p-single-exhibitors-section-main__title");
    if (!titleElement) {
      throw new Error("titleElement is null");
    }
    titleElement.textContent = exhibitor.title;

    const companyNameElement = document.querySelector(".p-single-exhibitors-section-main__company-name");
    if (!companyNameElement) {
      throw new Error("companyNameElement is null");
    }
    companyNameElement.textContent = exhibitor.companyName;

    const overviewElement = document.querySelector(".p-single-exhibitors-section-main__overview");
    if (!overviewElement) {
      throw new Error("overviewElement is null");
    }
    overviewElement.innerHTML = exhibitor.overview;

    const profileImageElement = document.querySelector<HTMLImageElement>(".p-single-exhibitors-section-main__profile-image");
    if (!profileImageElement) {
      throw new Error("profileImageElement is null");
    }
    profileImageElement.src = exhibitor.companyImage.url;


    const profileNameElement = document.querySelector(".p-single-exhibitors-section-main__profile-name");
    if (!profileNameElement) {
      throw new Error("profileNameElement is null");
    }
    profileNameElement.textContent = exhibitor.companyName;

    const profileProfileElement = document.querySelector(".p-single-exhibitors-section-main__profile-profile");
    if (!profileProfileElement) {
      throw new Error("profileProfileElement is null");
    }
    profileProfileElement.innerHTML = exhibitor.companyProfile;


    const companyOverviewElement = document.querySelector(".p-single-exhibitors-section-main__company-overview");
    if (!companyOverviewElement) {
      throw new Error("companyOverviewElement is null");
    }


    const companyOverviewAndDataList = EXHIBITOR_COMPANY_OVERVIEW_LIST.map((companyOverview) => {

      const data = exhibitor[companyOverview.field] as string;

      return { data, ...companyOverview };
    }).filter((companyOverviewAndData) => companyOverviewAndData.data !== undefined);

    if (companyOverviewAndDataList.length === 0) {
      companyOverviewElement.remove();
    } else {
      const tableElement = companyOverviewElement.querySelector(".p-single-exhibitors-section-main__company-overview-table");
      if (!tableElement) {
        throw new Error("tableElement is null");
      }
      for (const companyOverviewAndData of companyOverviewAndDataList) {
        const trElement = document.createElement("tr");
        trElement.classList.add("p-single-exhibitors-section-main__company-overview-tr");
        tableElement.appendChild(trElement);
        const thElement = document.createElement("th");
        thElement.classList.add("p-single-exhibitors-section-main__company-overview-th");
        thElement.textContent = companyOverviewAndData.header;
        trElement.appendChild(thElement);
        const tdElement = document.createElement("td");
        tdElement.classList.add("p-single-exhibitors-section-main__company-overview-td");
        tdElement.textContent = companyOverviewAndData.data;
        trElement.appendChild(tdElement);
      }
    }


    // document.title = `${exhibitor.title}`;

    if (IS_DEBUG) {
      console.log(exhibitor);
    }
  }).catch((error) => {
    myError(`error.message: ${error.message}`)
    console.error(error);
  });

} else {
  const errorMessage = "Missing 'id' in URL.";
  myError(errorMessage)
  console.error(errorMessage);

}
